import { Button } from "./ui/button"

interface PriceButtonProps {
    price: number;
    isSelected: boolean;
    onClick: () => void;
}

export function PriceButton({ price, isSelected, onClick }: PriceButtonProps) {
    return (
        <Button 
            className={`${isSelected ? 'bg-blue' : 'bg-blue-dark'} text-white font-semibold text-xl h-12`} 
            onClick={onClick}
            {...(price === 150 ? { shine: true } : {})}
            debounceTime={0}
        >
            {price}
        </Button>
    )
}